import { createContext, type RefObject } from 'react';

export const TimeseriesChartOverlayRefContext = createContext<
  RefObject<HTMLDivElement | null> | undefined
>(undefined);
